const initModuleEimzo = async () => {
  return await import("./EIMZO.js");
};
export { initModuleEimzo };
